import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { AppTextService } from '../../../../shared/app-text';
import { FiDialogsService } from '../../../../shared/fi-dialogs';
import { FiSiteDesignHelperService } from '../../../fi-site-design-helper.service';
import { FiBrandEditorSiteNameEditorDialogComponent } from './fi-brand-editor-site-name-editor-dialog/fi-brand-editor-site-name-editor-dialog.component';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';

@Component({
    selector: 'fi-brand-editor-site-name-card',
    templateUrl: './fi-brand-editor-site-name-card.component.html',
    styleUrls: ['./fi-brand-editor-site-name-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-brand-editor-site-name-card' },
    standalone: false,
})
export class FiBrandEditorSiteNameCardComponent {
    @Input() brandName: string;
    @Output() brandNameChange = new EventEmitter<string>();

    constructor(
        private appTextService: AppTextService,
        private fiDialogsService: FiDialogsService,
        private fiSiteDesignHelperService: FiSiteDesignHelperService,
        private cdr: ChangeDetectorRef,
        private saveChangesWarningService: SaveChangesWarningService,
    ) {}

    openEditSiteNameDialog() {
        this.fiDialogsService
            .openAnimatedBottomDialog({
                contentComponentRef: FiBrandEditorSiteNameEditorDialogComponent,
                contentComponentData: this.brandName,
                headerText: this.appTextService.get('site_design.change_brand_name'),
                yesButtonText: this.appTextService.get('done'),
                isNewButtonsUI: true,
                config: {
                    height: '250px',
                    closeOnNavigation: false,
                },
            })
            .onYesButtonClick((result: string) => {
                if (result !== this.brandName) {
                    this.brandName = result;
                    this.brandNameChange.emit(result);
                    this.fiSiteDesignHelperService.setBrandSettingsChanged(true);
                    this.cdr.markForCheck();
                }
            })
            .afterClosed(() => (this.saveChangesWarningService.closeDialogOnTransition = false));
        this.saveChangesWarningService.closeDialogOnTransition = true;
    }
}
